/* 
* File: \app\resourceCenter\shared\service\resSharedService.js
* Description: 
* Create Date: 2020-05-21
* Author: he.jianbo
* Author Email: hjb2722404@163.com
* -----
* Last Modified: 2020-05-21 下午12:25:07
* Modified By: he.jianbo
* modify description: 
 */

angular
    .module('resourceCenterSharedModule')
    .service('resSharedService', ['localStorageService', function(localStorageService){
        return {
            getListMode: getSharedListModeFromLocal,
            setListMode: setSharedListModeToLocal
        };

        /**
         * [setSharedListModeToLocal 将用户当前选择的共享稿库列表展示模式存入本地缓存]
         *
         * @param   {[type]}  mode  [mode description]
         *
         * @return  {[type]}        [return description]
         */
        function setSharedListModeToLocal(mode){
            localStorageService.set('resSharedListMode', mode);
        }

        /**
         * [getSharedListModeFromLocal 从本地缓存获取共享稿库列表展示模式]
         *
         * @return  {[type]}  [return description]
         */
        function getSharedListModeFromLocal(){
            let listMode = localStorageService.get('resSharedListMode');
            return listMode || 'banmian';
        }
    }]);